/**
 * Instagram-specific social stats hook factory
 */

import type { InstagramCreator, Maybe } from '@frontend/gql/social/graphql';
import { useSocialStats } from '@/shadcn/components/social-stats/hooks/useSocialStats';
import { instagramSocialStatsAdapter } from '@/applications/Social/creator-search/instagram/adapters/instagram-social-stats-adapter';
import type { SocialStatsHookReturn } from '@/types/social-stats';

/**
 * Instagram-specific social stats hook
 * @param isLoading - Loading state
 * @param creator - Instagram creator data
 * @param defaultTab - Default tab to show
 * @returns Social stats hook properties
 */
export const useInstagramSocialStats = (
  isLoading: boolean,
  creator?: Maybe<InstagramCreator>,
  defaultTab?: string
): SocialStatsHookReturn => {
  return useSocialStats(
    instagramSocialStatsAdapter,
    isLoading,
    creator,
    defaultTab
  );
};
